export const PAGE_SIZES = [10, 20, 50, 100, 200];

export const PAGE_SIZES_MEDIUM = [10, 20, 30, 40, 50];

// for easy testing of pagination on small pages sizes use this instead
// export const PAGE_SIZES = [1, 2, 5, 10, 20];
